import { PropsWithChildren, useEffect, useRef } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { Item } from './Item';
import { SortableItemProps } from '../types';
import { useMountStatus } from '../hooks';

export function SortableItem({
  id,
  index,
  renderItem,
  children,
  disabled,
}: PropsWithChildren<SortableItemProps>) {
  const {
    setNodeRef,
    // setActivatorNodeRef,
    listeners,
    isDragging,
    isSorting,
    transform,
    transition,
  } = useSortable({
    id,
  });
  const mounted = useMountStatus();
  const mountedWhileDragging = isDragging && !mounted;
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (ref) setNodeRef(ref.current);
  }, [ref]);

  return (
    <Item
      disabled={disabled}
      dragging={isDragging}
      fadeIn={mountedWhileDragging}
      index={index}
      listeners={listeners}
      ref={ref}
      renderItem={renderItem}
      sorting={isSorting}
      transform={transform}
      transition={transition}
      value={id}
    >
      {children}
    </Item>
  );
}
